export const styles = {
  tagCloudSearch: {
    flex: 2,
  },
};
